var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitterLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-comment-24x24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25,0 L3.75,0 C1.67892187,0 0,1.67892008 0,3.74999599 L0,15.7499832 C0,17.8210591 1.67892187,19.4999792 3.75,19.4999792 L18.4425,19.4999792 L22.7175,23.7824746 C22.8590625,23.9228651 23.0506406,24.0011462 23.25,23.9999873 C23.6642344,23.9999873 24,23.6642091 24,23.2499751 L24,3.74999599 C24,1.67892008 22.3210781,0 20.25,0 Z M22.5,21.4424771 L19.2825,18.2174805 C19.1409844,18.07709 18.9493594,17.9988089 18.75,17.9999808 L3.75,17.9999808 C2.50734375,17.9999808 1.5,16.9926381 1.5,15.7499832 L1.5,3.74999599 C1.5,2.50734107 2.50734375,1.4999984 3.75,1.4999984 L20.25,1.4999984 C21.4926562,1.4999984 22.5,2.50734107 22.5,3.74999599 L22.5,21.4424771 Z",
    id: "Shape",
    fill: "#3B7FF5",
    fillRule: "nonzero",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3B7FF5",
    x: 5,
    y: 9,
    width: 14,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#3B7FF5",
    x: 5,
    y: 5,
    width: 11,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#3B7FF5",
    x: 5,
    y: 13,
    width: 8,
    height: 1.5,
    rx: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitterLight);
export default __webpack_public_path__ + "static/media/gitter-light.d26712c3333d91dc9c194742d4daebb2.svg";
export { ForwardRef as ReactComponent };